export default (state = {}, action) => {
  switch (action.type) {
    case  'SET_MODAL':
      return {...state, ...action.data}
    case 'UNSET_MODAL':
      return null
    default:
      return state;
  }
}